export default "__VITE_ASSET__DTbPUGZY__"